const points = [
  {
    icon: '💻',
    title: 'On your machine, not a vendor’s',
    description:
      'The app captures your mic and system audio locally — whatever meeting app you use, no bot dials in, and Solidly never sees your call. There is nothing for the other side to admit into the room.',
  },
  {
    icon: '🔑',
    title: 'Your transcription key',
    description:
      'Audio streams from your machine to AssemblyAI on your own API key — best-in-class live transcription, paid by you, to them, for exactly what you transcribe. No intermediary reselling your meeting back to you.',
  },
  {
    icon: '🪪',
    title: 'Voiceprints learn who’s who',
    description:
      'Real diarization, no bot in the call: the app learns voices across meetings, you confirm who’s who, and you can adjust the speaker count when it miscounts. Names stick from one meeting to the next.',
  },
];

const Meetings = () => {
  return (
    <section className="meetings" id="capture">
      <div className="section-container">
        <p className="overline overline--center">HOW CAPTURE WORKS</p>
        <h2 className="section-title">No bot ever joins. By design.</h2>
        <p className="section-subtitle">
          Other meeting assistants dial a bot into your call and record to the cloud. Solidly Meet
          captures audio on your own machine — nothing joins the call, nothing ships to a vendor,
          and your data lives in a local database on your device.
        </p>

        <div className="meetings-callout">
          <span className="meetings-callout-bad">🤖 “A notetaker bot has joined the call.”</span>
          <span className="meetings-callout-arrow" aria-hidden="true">→</span>
          <span className="meetings-callout-good">Nothing joins. Claude sits on your side of the glass.</span>
        </div>

        <div className="meetings-grid">
          {points.map((p, i) => (
            <div key={i} className="feature-card">
              <div className="feature-icon" aria-hidden="true">
                {p.icon}
              </div>
              <h3>{p.title}</h3>
              <p>{p.description}</p>
            </div>
          ))}
        </div>

        <div className="meetings-note mono">
          Local-first, end to end — transcripts and notes live in SQLite on your device, not in
          anyone’s cloud account.
        </div>
      </div>
    </section>
  );
};

export default Meetings;
